import type { Content } from "../elev8Api/contentTypes";
import type { Provider } from "$lib/proofOfPlay/providerHelpers";

const APP_NAME = "elev8-anywhere";
const PLAY_EVENT = "content.play";
const POP_EVENT = "content.pop";

type Environment = "production" | "preview";
type PopStatus = "OK" | "NOT_OK" | "FAIL" | "UNKNOWN";

type PlayEventContent = Content & {
  duration: number;
};

interface DataPipelineEventPayload {
  display_id: string;
  app: typeof APP_NAME;
  event: string;
  isLoop?: boolean;
}

interface DataPipelinePlayEventPayload extends DataPipelineEventPayload {
  event: typeof PLAY_EVENT;
  content: PlayEventContent;
  env: Environment;
}

interface DataPipelinePopEventPayload extends DataPipelineEventPayload {
  event: typeof POP_EVENT;
  provider: Provider;
  status: PopStatus;
  statusMessage: string;
  response: string | unknown;
  callback_url: string;
  creative_id: string;
}

interface DataPipelineEvent {
  uuid: string;
  start_at_utc: number;
  start_at_local: string;
  payload: DataPipelineEventPayload;
  metadata: any;
}

export type {
  DataPipelineEvent,
  Environment,
  Content,
  DataPipelineEventPayload,
  DataPipelinePlayEventPayload,
  DataPipelinePopEventPayload,
  PopStatus,
};

export { APP_NAME, PLAY_EVENT, POP_EVENT, type PlayEventContent };
